import { useTranslation } from 'react-i18next';
import Tooltip from '../problem-solvers/tooltip';
import Widget from '../../../../../../../../Analysis/widget';
import { renderTooltipJsx } from '../../../../../../../../../helpers/Tooltip';
import Chart from '../../../../../../../pme/screens/dashboard/widgets/sdgs/chart';
import { useState } from 'react';
import { useCallback } from 'react';
import { DashboardService } from '../../../../../../../../../services';
import { useEffect } from 'react';

export const distributionColors = [
  '#CDE1D0', '#B4D3B9', '#9BC4A1', '#82B88A',
];

export default function FieldStories({ partnersLoading, selectedParters }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (partnersLoading) {
      return;
    }

    setLoading(true);

    try {
      const { data } = await DashboardService.getTestimonials(selectedParters);
      const total = Object.keys(data).reduce((all, key) => all + (data[key] || 0), 0);

      setData(total ?
        ['grievance', 'observation', 'request', 'successStory'].reduce((all, key) => {
          if (data[key]) {
            all.push({
              name: key,
              value: data[key],
              percent: (data[key] || 0) / total,
              color: distributionColors[all.length] || '#82B88A',
            })
          }

          return all;
        }, [])
        : []
      )
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [selectedParters, partnersLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const isEmpty = !data.length;

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    let label = 'Testimonials';

    switch (item.name) {
      case 'request':
        label = 'Requests';
        break;
      case 'grievance':
        label = 'Grievances';
        break;
      case 'observation':
        label = 'Observations';
        break;
      case 'successStory':
        label = 'Success stories';
        break;
      default:
    }

    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        children={renderTooltipJsx({
          title: t('Testimonials'),
          items: [
            {
              color: !isEmpty ? item.color : '#E5E7EB',
              label: t(label),
              value: !isEmpty ? Number(item.value).toLocaleString('en-us') : 0,
            },
          ]
        })}
      />
    )
  }

  return (
    <Widget
      loading={loading}
      title={t('Stories from the Field')}
      className="with-border-header custom-width-b">
      <div className='flex flex-1 flex-column justify-content-center pl-4 pr-4'>
        <div className='flex justify-content-center'>
          <Chart
            changeOpacityOnHover={false}
            data={data}
            isPie
            t={t}
            isEmpty={isEmpty}
            renderTooltip={_renderTooltip}
            yOffset={50}
            className="no-max-width small-chart"
          />
        </div>
      </div>
    </Widget>
  );
}
